/**
 * State FIPS ↔ USPS abbreviation ↔ name crosswalk.
 *
 * The coverage pipeline straddles three identifier systems: BigQuery's
 * `jurisdiction_state` is a 2-letter USPS code ('CO'), the us-atlas TopoJSON
 * and Census reference files key states by 2-digit FIPS ('08'), and the UI
 * shows the full name. This bundles the (stable) mapping so all three line up.
 */
const STATE_TABLE = [
    ['01', 'AL', 'Alabama'],
    ['02', 'AK', 'Alaska'],
    ['04', 'AZ', 'Arizona'],
    ['05', 'AR', 'Arkansas'],
    ['06', 'CA', 'California'],
    ['08', 'CO', 'Colorado'],
    ['09', 'CT', 'Connecticut'],
    ['10', 'DE', 'Delaware'],
    ['11', 'DC', 'District of Columbia'],
    ['12', 'FL', 'Florida'],
    ['13', 'GA', 'Georgia'],
    ['15', 'HI', 'Hawaii'],
    ['16', 'ID', 'Idaho'],
    ['17', 'IL', 'Illinois'],
    ['18', 'IN', 'Indiana'],
    ['19', 'IA', 'Iowa'],
    ['20', 'KS', 'Kansas'],
    ['21', 'KY', 'Kentucky'],
    ['22', 'LA', 'Louisiana'],
    ['23', 'ME', 'Maine'],
    ['24', 'MD', 'Maryland'],
    ['25', 'MA', 'Massachusetts'],
    ['26', 'MI', 'Michigan'],
    ['27', 'MN', 'Minnesota'],
    ['28', 'MS', 'Mississippi'],
    ['29', 'MO', 'Missouri'],
    ['30', 'MT', 'Montana'],
    ['31', 'NE', 'Nebraska'],
    ['32', 'NV', 'Nevada'],
    ['33', 'NH', 'New Hampshire'],
    ['34', 'NJ', 'New Jersey'],
    ['35', 'NM', 'New Mexico'],
    ['36', 'NY', 'New York'],
    ['37', 'NC', 'North Carolina'],
    ['38', 'ND', 'North Dakota'],
    ['39', 'OH', 'Ohio'],
    ['40', 'OK', 'Oklahoma'],
    ['41', 'OR', 'Oregon'],
    ['42', 'PA', 'Pennsylvania'],
    ['44', 'RI', 'Rhode Island'],
    ['45', 'SC', 'South Carolina'],
    ['46', 'SD', 'South Dakota'],
    ['47', 'TN', 'Tennessee'],
    ['48', 'TX', 'Texas'],
    ['49', 'UT', 'Utah'],
    ['50', 'VT', 'Vermont'],
    ['51', 'VA', 'Virginia'],
    ['53', 'WA', 'Washington'],
    ['54', 'WV', 'West Virginia'],
    ['55', 'WI', 'Wisconsin'],
    ['56', 'WY', 'Wyoming'],
    ['60', 'AS', 'American Samoa'],
    ['66', 'GU', 'Guam'],
    ['69', 'MP', 'Northern Mariana Islands'],
    ['72', 'PR', 'Puerto Rico'],
    ['78', 'VI', 'U.S. Virgin Islands'],
];
export const STATES = STATE_TABLE.map(([fips, abbr, name]) => ({
    fips,
    abbr,
    name,
}));
const BY_FIPS = new Map(STATES.map((s) => [s.fips, s]));
const BY_ABBR = new Map(STATES.map((s) => [s.abbr, s]));
/** USPS abbreviation for a 2-digit state FIPS, or undefined if unknown. */
export function stateFipsToAbbr(fips) {
    return BY_FIPS.get(fips)?.abbr;
}
/** 2-digit state FIPS for a USPS abbreviation (case-insensitive). */
export function stateAbbrToFips(abbr) {
    return BY_ABBR.get(abbr.toUpperCase())?.fips;
}
/** Full state name from either a FIPS code or a USPS abbreviation. */
export function stateName(fipsOrAbbr) {
    return (BY_FIPS.get(fipsOrAbbr) ?? BY_ABBR.get(fipsOrAbbr.toUpperCase()))?.name;
}
/** First two characters of a 5-digit county FIPS — its state FIPS. */
export function countyFipsToStateFips(countyFips) {
    return countyFips.slice(0, 2);
}
//# sourceMappingURL=states.js.map